import styled from 'styled-components'

import { WithTooltip } from '@ui/elements/Tooltip'

/**
 * The label icon's tooltip trigger. As an inline-flex box it is exactly the
 * icon's height (no text strut of its own), and aligned to the top of the
 * label's line box it keeps the row at the plain label's height. The gap
 * before the icon is the trigger's own margin, so its focus ring outlines the
 * icon alone.
 */
export const FieldLabelIconStyled = styled(WithTooltip.Wrapper)`
  display: inline-flex;
  margin-left: ${(props) => props.theme.space.xsmall};
  vertical-align: top;
`
